const URL = "https://blogpostapi.cyclic.app";
export default URL;
